import {PERSON_ACTIVE_CONTEXTS_SELECTED} from "../actions";

export default function(state = {}, action) {

//20190219
//payload is fuller dataset from db when already exists
//payload is just id from the new process -- from action createNewPersonForUser

  switch (action.type) {
    case PERSON_ACTIVE_CONTEXTS_SELECTED:
      //console.log('rdcr_active_person_contexts_selected action -- PERSON_ACTIVE_CONTEXTS_SELECTED --', action.payload)
      return action.payload;
    default:
      return state;
  }
}
